import React, { useState, ChangeEvent } from "react";
import '../styles/SearchBar.css';
import useDebounce from "../hooks/useDebounce";

interface SearchBarProps {
  placeholder: string;
  onSearch: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder, onSearch }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { createDebounce } = useDebounce();
  const debouncedSearch = createDebounce(onSearch, 500);

  const wordCount = searchTerm.trim() ? searchTerm.trim().split(/\s+/).length : 0;
  const showCounter = wordCount >= 4;

  return (
    <div className="search-bar-wrapper">
      <input
        type="text"
        placeholder={placeholder}
        className="search-bar"
        value={searchTerm}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setSearchTerm(e.target.value)
          debouncedSearch(e.target.value)
        }}
      />
      {showCounter && (
        <div className={`word-counter ${wordCount >= 6 ? 'limit' : wordCount >= 5 ? 'warning' : ''}`}>
          {wordCount >= 6
            ? `⚠️ Máximo 6 palabras (${wordCount} detectadas)`
            : `${wordCount} / 6 palabras`}
        </div>
      )}
    </div>
  );
};

export default SearchBar;